import { Iscrizione } from "../../../directus";

export class IscrizioneObj {
  id: number = -1;
  status: number = 0;
  nome: string = '';
  cognome: string = '';
  azienda: string = '';
  email: string = '';
  profilo: string = '';
  edizione: number = -1;
  confermata: number = 0;
  presenza: number = 0;
  date_created: any;
  date_updated: any;
  orario: any = null;

  b64BadgeImage: any;

  constructor(source: Partial<Iscrizione>) {
    Object.assign(this, source);
  }

  isValid(): boolean{
    if (this.id && this.id > 0) {
      return true;
    }
    return false;
  }
}
